<template>
  <div  id="app" class="pa-0" v-if="fontFamily" :style="'--fontFamily: ' + fontFamily.value">
    <div v-if="currentCompany && currentCompany.custom_properties.message" class="pa-2 background">
      <v-alert v-model="display_company_msg" @input="display_company_msg = false" class=" ma-0 primary--text" dismissible outline>
        <div :class="['subheading', $vuetify.breakpoint.width > 959 ? 'text-xs-center' : '','ma-0','primary--text' ]" v-html="currentCompany.custom_properties.message">
          {{currentCompany.custom_properties.message}}
        </div>
      </v-alert>
    </div>

     <v-progress-linear
      v-if="loader"
      :active="loader"
      color="primary"
      :indeterminate="true"
      class="ma-0"
      height="5"
      style="top: -2px;"
    ></v-progress-linear>

    <v-snackbar
      v-model="snackbar.show"
      :bottom="snackbar.y === 'bottom'"
      :left="snackbar.x === 'left'"
      :multi-line="snackbar.mode === 'multi-line'"
      :right="snackbar.x === 'right'"
      :timeout="snackbar.timeout"
      :top="snackbar.y === 'top'"
      :vertical="snackbar.mode === 'vertical'"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-icon  class="secondary--text" @click="snackbar.show = false">close</v-icon>
    </v-snackbar>

    <!-- Alert -->
    <alert-message :dialog="dialog"></alert-message>
    <template v-if="layout == authLayout">
      <auth-layout></auth-layout>
    </template>

    <template v-if="!companyCheckingModel">
      <template v-if="layout == companyLayout">
        <company-layout></company-layout>
      </template>
    </template>

    <template v-if="layout == guestLayout">
      <guest-layout></guest-layout>
    </template>
    <template v-if="layout == noLayout">
      <no-layout></no-layout>
    </template>
    <SupportForm />

    <v-card v-if="companyCheckingModel" height="100vh" flat class="secondary--text">
      <v-layout class="text-xs-center" fill-height align-center justify-center>
            <!-- <h1>{{ $t("screener.company.loader.message") }}</h1> -->
            <v-progress-circular
              indeterminate
              size="70"
              color="primary"
            ></v-progress-circular>
      </v-layout>
    </v-card>

  </div>
</template>

<script>
import GuestLayout from "@/layouts/GuestLayout";
import CompanyLayout from "@/layouts/CompanyLayout";
import AuthLayout from "@/layouts/AuthLayout";
import NoLayout from "@/layouts/NoLayout"
import AlertMessage from "./components/dialogBox/AlertMessage";
import { EventBus } from "@/event-bus";
import { mapGetters, mapState } from "vuex";
import DEFINES from "@/defines";
import { mapFields } from "vuex-map-fields";
import i18n from "@/i18n";
import { getAuthHash, getCookieUrlImg } from "@/api/_manager";
import SupportForm from "@/components/SupportForm";
export default {
  name: "app",
  components: {
    GuestLayout,
    AlertMessage,
    CompanyLayout,
    AuthLayout,
    NoLayout,
    SupportForm,
  },
  data() {
    return {
      loader: false,
      companyCheckingModel: true,
      dialog: {
        show: false,
        text: "",
        color: ""
      },
      guestLayout: DEFINES.LAYOUT_GUEST,
      companyLayout: DEFINES.LAYOUT_COMPANY,
      authLayout: DEFINES.LAYOUT_AUTH,
      noLayout: DEFINES.LAYOUT_NO,
      snackbar:{
        show: false,
        text: "",
        color: "primary",
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 5000,
      }
    };
  },
  computed: {
    ...mapGetters("app", {
      layout: "appLayout",
      fontFamily : "fontFamily"
    }),
    ...mapFields("consumer", {
      consumer_uuid: "uuid",
    }),
    ...mapFields("company", {
      display_company_msg: "display_company_msg",
    }),
    ...mapState({
      currentCompany: state => state.company.company
    }),
  },

  mounted(){
    this.initByDomain();
    this.loadFonts();
    this.loadNewrelicApn();
  },
   watch: {
    fontFamily: {
      deep: true,
      handler:function(){
        this.loadFonts();
      },
    },
  },

  created() {
    EventBus.$on("showMessage", payload => {
      this.dialog.show = true;
      this.dialog.color = payload.color;
      this.dialog.text = payload.message;
    });

    EventBus.$on("hideMessage", payload => {
      this.dialog.show = false;
    });

    EventBus.$on("showAlert", payload => {
      this.snackbar.color = payload.color || "primary";
      this.snackbar.text = payload.message;
      this.snackbar.y = payload.y || 'top';
      this.snackbar.x = payload.x || 'right';
      this.snackbar.mode = payload.mode || '';
      this.snackbar.timeout = payload.timeout || 5000;
      this.snackbar.show = true;
    });

    EventBus.$on("hideAlert", payload => {
      this.snackbar.show = false;
      this.snackbar.text = null;
    });

    EventBus.$on("showLoader", payload => {
      this.loader = true;
    });

    EventBus.$on("hideLoader", payload => {
      this.loader = false;
    });

    EventBus.$on("showSupportNotification", payload => {
      this.triggerNotification(payload);
    });
  },

  methods: {
    loadFonts(){
      var _this = this;
      var junction_font = new FontFace(this.fontFamily.value, `url(${this.fontFamily.url})`);
        junction_font.load().then(function(loaded_face) {
          document.fonts.add(loaded_face);
            document.body.style.fontFamily = _this.fontFamily.value;
        }).catch(function(error) {
      });
    },

    async initByDomain(){
      try {
        await this.$store.dispatch("company/initByDomain", {
          domain : window.location.protocol + "//" + window.location.host
        });
        this.companyCheckingModel = false;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

    triggerNotification(payload) {
      if(payload.screener_id != this.$route.params.screener_id){
        return;
      }
      const icon = `https://api.iconify.design/mdi:close-circle-outline.svg?color=%23fff&height=24`;
      const title = this.currentCompany
        ? this.currentCompany.title
        : i18n.t("screener.support");
      const body = payload.message;
      const config = {
        titleMaxLength: 50,
        bodyMaxLength: 500,
        icon: icon,
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        position: "rightCenter"
      };
      this.$snotify.info(body, title, config);
      if(this.DEFINES.NODE_ENV === 'production'){
        this.$ga.event({
          eventCategory: 'screener.live_notification',
          eventAction: 'receive_live_notification >> at '+ new Date().getTime() +' >> in >> '+payload.screener_id,
          eventLabel: payload.message,
          eventValue: 1
        })
      }
    },

    /**
     * Load New relic script dynamically
     * REASON: In previous code indexhtml was responsible for loading this script
     * but it was only for the movieseverywhere.net and was not working for whitelabel
     */
    loadNewrelicApn() {
       if(DEFINES.NODE_ENV === 'production'){
          let externalScript = document.createElement('script')
          externalScript.setAttribute('src', 'newrelic-apn.js')
          document.head.appendChild(externalScript)
       }
    },
  }
};
</script>
<style scoped>
.v-alert.v-alert--outline {
    border: 3px solid var(--v-primary-base) !important;
    line-height: 5px;
}
#app {
  font-family: var(--FontFamily) !important;
}
</style>
